import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IBankExportDetail } from "./bankExport";
import BankExportDownloadResponse from "./bankExportDownloadResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundExportDetailResponse implements IBankExportDetail {
  id!: string;

  @observable
  name!: string;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  createdBy!: string;

  @observable
  paymentsIncludedCount!: number;

  @observable
  @Type(() => BankExportDownloadResponse)
  downloads!: BankExportDownloadResponse[];
}
